'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { AngleLeft, AngleRight } from '@zooplus/icons';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from '../Carousel.module.scss.js';

const { elementTestLabel } = getTestLabels('Carousel');
const CarouselNav = (props) => {
    const { nextButtonAriaLabel, nextClick, nextButtonDisabled, previousButtonAriaLabel, prevClick, previousButtonDisabled, } = props;
    return (jsxs(Fragment, { children: [jsx("button", { type: "button", "data-zta": elementTestLabel('PreviousButton'), className: classNames(style['z-carousel-beta__arrow'], style['z-carousel-beta__arrow--prev']), onClick: prevClick, disabled: previousButtonDisabled, children: jsx(AngleLeft, { "aria-label": previousButtonAriaLabel }) }), jsx("button", { type: "button", "data-zta": elementTestLabel('NextButton'), className: classNames(style['z-carousel-beta__arrow'], style['z-carousel-beta__arrow--next']), onClick: nextClick, disabled: nextButtonDisabled, children: jsx(AngleRight, { "aria-label": nextButtonAriaLabel }) })] }));
};

export { CarouselNav };
//# sourceMappingURL=CarouselNav.js.map
